import {
  deepLinkParser,
  type DeeplinkRedirect,
} from '~/lib/category/deepLinkParser';

export const useDeepLinkParser = async (
  deeplink: string
): Promise<DeeplinkRedirect> => {
  if (!deeplink) return null;

  const { $db } = useNuxtApp();

  const contents = useContents();

  const route = useRoute();

  return await deepLinkParser(
    $db,
    deeplink,
    contents.all.value,
    contents.mainContent.value,
    route.path === '/'
  );
};
